import React from 'react'
import Image from '../general/Image'

const SkillCard = ({ keyName, icon, name, onClick, isActive, extraClass = '', supportsExperience = false, onExperienceChange = undefined }) => {

  const handleOnClick = (e) => {
    if (e.target.id === 'experience-container' || e.target.id === 'experience-input')
      return;
    onClick();
  }

  const handleOnChange = (e) => {
    if (onExperienceChange) {
      onExperienceChange(e.target.value);
    }
  }

  return (
    <div onClick={handleOnClick} key={keyName} className={`bg-[#292929] flex justify-start p-[8px] items-center gap-[20px] rounded-[6px] cursor-pointer ${isActive ? 'bg-black border border-primary-color' : ''} ${extraClass}`}>
      {
        icon ?
          <Image src={icon} className='w-[30px] h-[30px]' />
          :
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 w-[30px] h-[30px] text-white">
            <path strokeLinecap="round" strokeLinejoin="round" d="M4.26 10.147a60.438 60.438 0 0 0-.491 6.347A48.62 48.62 0 0 1 12 20.904a48.62 48.62 0 0 1 8.232-4.41 60.46 60.46 0 0 0-.491-6.347m-15.482 0a50.636 50.636 0 0 0-2.658-.813A59.906 59.906 0 0 1 12 3.493a59.903 59.903 0 0 1 10.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.717 50.717 0 0 1 12 13.489a50.702 50.702 0 0 1 7.74-3.342M6.75 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm0 0v-3.675A55.378 55.378 0 0 1 12 8.443m-7.007 11.55A5.981 5.981 0 0 0 6.75 15.75v-1.5" />
          </svg>
      }

      {
        (supportsExperience && !isActive) && (
          <p className='text-[0.9rem] select-none'> {name} </p>
        )
      }

      {
        !supportsExperience && (
          <p className='text-[0.9rem] select-none'> {name} </p>
        )
      }

      {
        supportsExperience && isActive && (
          <div id='experience-container'>
            <input onChange={handleOnChange} id='experience-input' type="text" className='rounded-[6px] border border-gray-500 bg-black text-white placeholder:text-[8px] px-[10px] h-[30px] w-full outline-none text-[12px]' placeholder='Exp. in years' />
          </div>
        )
      }
    </div>
  )
}

export default SkillCard